/**
 * The wall-clock encoding the Create Workshop drawer sends: a `YYYY-MM-DD` date
 * and `HH:MM` time become an ISO string whose digits are the venue's clock,
 * tagged `Z` only so the API decodes them without the browser's own zone.
 */

/** Combine a YYYY-MM-DD date + HH:MM time into the wall-clock ISO string. */
export function toIso(date: string, time: string): string {
  return new Date(`${date}T${time}:00.000Z`).toISOString();
}

/** The same encoding as a Date, or null when the pair is incomplete or junk. */
export function toWallClock(date: string, time: string): Date | null {
  if (!date || !time) return null;
  const d = new Date(`${date}T${time}:00.000Z`);
  return Number.isNaN(d.getTime()) ? null : d;
}
